import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    IFurtherPaymentDays
} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/IFurtherPaymentDays";


const useApiGetFurtherPaymentDays = (pk: number | undefined): UseQueryResult<IFurtherPaymentDays, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<IFurtherPaymentDays> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/further_payment_days/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetFurtherPaymentDays", pk],
        queryFn: () => doGet(selectedCompany?.company_token, pk),
        enabled: !!pk
    })
};

export default useApiGetFurtherPaymentDays